import React from 'react'
import block from 'bem-cn'

import TopHeader from './TopHeader/TopHeader'

import './HeaderMobile.scss'

const b = block('header-block-mobile')

export const HeaderMobile: React.FC = () => (
  <header className={b()}>
    <TopHeader />
  </header>
)
